import ErrorMessage from './ErrorMessage-redux';

export default ErrorMessage;
